import * as React from 'react';

import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';

import { InsightsNone } from './InsightsNone';

interface InsightsInsufficientDataProps {
  activityInstanceId: number;
  averageScoreRate?: number | null;
}

export function InsightsInsufficientData({
  activityInstanceId,
  averageScoreRate,
}: InsightsInsufficientDataProps) {
  React.useEffect(() => {
    toast.critical(translate('Insufficient data to display insights'));
  }, []);

  return (
    <InsightsNone
      activityInstanceId={activityInstanceId}
      averageScoreRate={averageScoreRate}
    />
  );
}
